import React, { FunctionComponent } from 'react';
import { Field } from 'formik';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
} from '@mui/material';

type RadioValue = string | boolean;

type RadioGroupFieldProps = {
    name: string;
    radios: {
        label: string;
        value: RadioValue;
    }[];
    label?: string;
    formControlClassName?: string;
    radioGroupClassName?: string;
    formLabelClassName?: string;
    onChange?: (
        value: RadioValue,
        setFieldValue: (name: string, value: RadioValue) => void
    ) => void;
};

export const RadioGroupField: FunctionComponent<
    React.PropsWithChildren<RadioGroupFieldProps>
> = ({
    formControlClassName,
    formLabelClassName,
    radioGroupClassName,
    label,
    name,
    onChange,
    radios,
}) => {
    return (
        <Field name={name}>
            {({ field: { name, value }, form: { setFieldValue } }) => (
                <FormControl
                    className={formControlClassName}
                    component='fieldset'
                >
                    {!!label && (
                        <FormLabel
                            className={formLabelClassName}
                            component='legend'
                        >
                            {label}
                        </FormLabel>
                    )}

                    <RadioGroup
                        className={radioGroupClassName}
                        name={name}
                        value={value}
                        onChange={(e) => {
                            const { value } = e.target;
                            let formValue: RadioValue = value;
                            if (value === 'true' || value === 'false') {
                                formValue = value === 'true';
                            }

                            if (onChange) {
                                onChange(formValue, setFieldValue);
                            } else {
                                setFieldValue(name, formValue);
                            }
                        }}
                    >
                        {radios.map(({ value, label }, index) => (
                            <FormControlLabel
                                key={index}
                                value={value}
                                control={<Radio />}
                                label={label}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            )}
        </Field>
    );
};
